import React from 'react';
import '../App.css';
import GoogleStore from '../assets/googbadge.svg'
import AppleStore from '../assets/appbadge.svg'
import RegisterScreen from '../assets/registerscreen.png'

const howText = "After installation, tenants can download the Gridspot mobile app. Once registered, they can access chargers, check availability, and reserve time—similar to platforms like ChargePoint. They can also contact our support team for any additional questions, concerns or issues.";

export default function HowItWorks() {
  return (
    <section className="section">
      <div className="container">
        <div className="section-head">
          <h2>How Does It Work?</h2>
          <p className="lead">{howText}</p>
        </div>
        <div className="how-grid">
          <article className="card how-card how-card-dark">
            <h3>Download App</h3>
            <p>Download Gridspot App From The Links Below</p>
            <div className="store-badges">
              <a href="https://play.google.com/store/apps/details?id=co.gridspot.app&pli=1"><img src={GoogleStore} alt="Get it on Google Play" width="180" height="54"/></a>
              <a href="https://apps.apple.com/us/app/gridspot/id6476886226"><img src={AppleStore} alt="Download on the App Store" width="180" height="54"/></a>
            </div>
          </article>
          <article className="card how-card how-card-register">
            <h3>Register or Login</h3>
            <p>Register or Login to the Gridspot Application</p>
            <img src={RegisterScreen} alt="Gridspot app registration screen" loading="lazy" width="716" height="775"/>
          </article>
          <article className="card how-card how-card-wide">
            <h3>Public or Private</h3>
            <p className="how-card-sub">Share or keep your charger private</p>
            <p>Join the Gridspot network to let your customers or tenants charge their vehicles without bearing the cost of electricity. You can charge a fee for usage based on your local utility rules. Please check with your local regulations before reselling electricity. Tenants and customers that need a charger can use the Gridspot app (or any similar OCPP 1.6 enabled app/service) to easily pay you for the power used at the rate you decide. Embrace the convenience and benefits of our collaborative charging solution today.</p>
          </article>
        </div>
      </div>
    </section>
  )
}
